import { Flex, Tag, Text } from "@chakra-ui/react"
import { FhResponseData } from "../../../../../../common/types/search"
import CustomImage from "../../../../../shared/CustomImage"
import { CClose } from "../../../../../shared/Icons"
import OverflowingText from "../../../../../shared/OverflowingText"

type Props = {
  category: FhResponseData
  handleCategorySelect: (_urlParams: string, categoryValue: string, isActive: boolean) => void
  isOverlayView?: boolean
}

export const LowerLevelCategoryTile = ({ category, handleCategorySelect, isOverlayView }: Props) => {
  const { link, nr, value, _imageurl } = category
  const isActive = category?.selected === true
  const categoryValue = value.value
  const categoryUrlParams = link.url_params

  return (
    <Flex
      key={categoryValue}
      w={isOverlayView ? "auto" : "72"}
      h={isOverlayView ? "11" : "10"}
      gap="2"
      px="4"
      align="center"
      justify="space-between"
      outline="1px solid"
      outlineColor={isActive ? "black" : "gray.350"}
      _hover={{ outlineColor: isActive ? "black" : "gray.500", cursor: "pointer" }}
      _active={{ outlineColor: isActive ? "gray.500" : "gray.900" }}
      onClick={() => handleCategorySelect(categoryUrlParams, categoryValue, isActive)}
    >
      <Flex alignItems="center" gap="2">
        {isOverlayView && !category.is_leaf_category && (
          <CustomImage src={_imageurl} alt={link.name} w="6" h="6" loading="eager" />
        )}
        <OverflowingText text={link.name} textAlign="start" />
      </Flex>
      {isActive ? (
        <CClose />
      ) : (
        <Tag borderRadius="full" bgColor="gray.200" flexShrink="0">
          <Text color="gray.900" fontSize="xs" fontWeight="medium">
            {nr}
          </Text>
        </Tag>
      )}
    </Flex>
  )
}
